export default "/blue-eye.b4a0e4aaed9dfd75d73517620b56bc26.svg";